<template>
  <v-row justify="center">
    <v-dialog v-model="active" persistent scrollable max-width="500">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Seleccione fecha
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense justify="center">
                  <v-col cols="12" v-if="searchType == 'date'">
                    <v-menu
                      ref="dateMenu"
                      v-model="dateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <ValidationProvider
                          name="fecha"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="date"
                            required
                            filled
                            rounded
                            class="rounded-small"
                            label="Fecha"
                            readonly
                            v-on="on"
                            :error-messages="errors"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        locale="es-us"
                        v-model="date"
                        :max="minDate"
                        scrollable
                        no-title
                      >
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="dateMenu = false"
                            >Cancelar</v-btn
                          >
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            rounded
                            :loading="isLoading"
                            :disabled="isLoading"
                            color="success"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="$refs.dateMenu.save(date)"
                            >ok</v-btn
                          >
                        </v-hover>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" v-else-if="searchType == 'range'">
                    <!-- <p class="grey--text caption pb-3">
                                            <v-icon small left color="blue-grey"
                                                >mdi-information</v-icon
                                            >Seleccione un rango de fecha para
                                            la búsqueda.
                                        </p> -->

                    <v-menu
                      ref="dateRangeMenu"
                      v-model="dateRangeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="dates"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dates"
                          required
                          filled
                          rounded
                          class="rounded-small"
                          label="Rango de fecha"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="es-us"
                        v-model="dates"
                        :max="new Date().toISOString().substr(0, 10)"
                        range
                        scrollable
                        no-title
                      >
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="dateRangeMenu = false"
                            >Cancelar</v-btn
                          >
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            rounded
                            :loading="isLoading"
                            :disabled="isLoading"
                            color="success"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="$refs.dateRangeMenu.save(dates)"
                            >ok</v-btn
                          >
                        </v-hover>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-hover v-slot:default="{ hover }">
              <!-- <v-btn
                                v-show="date"
                                text
                                rounded
                                class="mr-1"
                                v-if="module === 'productivityReport'"
                                :color="hover ? 'secondary' : 'grey'"
                                @click="downloadTodayCsv()"
                            >
                                Exportar CSV
                            </v-btn> -->
              <v-btn
                color="success"
                v-show="date"
                v-if="module === 'productivityReport'"
                @click="downloadTodayCsv()"
                small
                rounded
                fab
              >
                <v-icon>
                  mdi-download
                </v-icon>
              </v-btn>
            </v-hover>
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="closedialog('cerrar')"
                >Cancelar</v-btn
              >
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="isLoading"
                :disabled="isLoading || date == ''"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(closedialog)"
                >Buscar</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";
// import axios from "axios";
import moment from "moment";
import CdrDownloadToCsv from "@/components/Utils/CdrDownloadCsv";
// import { mapState } from "vuex";

export default {
  name: "DatePickerDialog",

  props: {
    active: Boolean,
    date: {
      type: String,
      required: false,
    },
    searchType: {
      type: String,
    },
    module: {
      type: String,
    },
  },

  components: {
    vuescroll,
  },

  data() {
    return {
      isLoading: false,
      dialog: false,
      dateMenu: false,
      dateRangeMenu: false,
      dates: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],

      // date: ""
    };
  },

  computed: {
    minDate() {
      let dayLimit;
      if (this.module !== "productivityReport")
        dayLimit = new moment().subtract(1, "day").format("YYYY-MM-DD");
      else dayLimit = new moment().format("YYYY-MM-DD");

      return dayLimit;
    },
  },

  methods: {
    closedialog(value = null) {
      if (this.searchType === "date") this.$emit("dialog:change", value, this.date);
      else if (this.searchType === "range")
        this.$emit("dialog:change", value, this.dates);

      // this.date = "";
    },

    async downloadTodayCsv() {
      let payload = { date: this.date };

      if (this.searchType == "range") {
        payload.date = this.dates[0];
        payload.dateEnd = this.dates[1];
      }
      if (this.searchType == "date") {
        payload.date = this.date;
      }
      try {
        await CdrDownloadToCsv(payload, this.module);
      } catch (err) {
        // console.log(err);
        this.$snotify.error(
          "No se pudo descargar los registros seleccionados.",
          "¡Error!"
        );
      }
    },
  },
};
</script>
